import { render, staticRenderFns } from "./price.vue?vue&type=template&id=46886a3c&scoped=true&"
import script from "./price.vue?vue&type=script&lang=js&"
export * from "./price.vue?vue&type=script&lang=js&"
import style0 from "./price.vue?vue&type=style&index=0&id=46886a3c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46886a3c",
  null
  
)

export default component.exports